import React, { useState } from 'react';
// import closeIcon from '../assets/svgs/close.svg'; // Add the correct path to your close icon
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

const MobileNav = ({mobileNav, handleMobileNav}) => {
  const [toggleMenu, setToggleMenu] = useState(true);
  
  const stateUser = useSelector((state) => state?.auth?.user); 
  

    const handleToggleMenu = () => {
        setToggleMenu(!toggleMenu);
    };

  return (
    <div className={`${mobileNav ? 'block' : 'hidden'} z-10`}>
         <div className="bg-white w-full fixed top-16 left-0 p-4">

<ul className="space-y-2">
  <li className="text-black hover:underline" onClick={handleMobileNav}>
      <Link to={"/dashboard"}>
  Dashboard
  </Link></li>
  <li className="text-black hover:underline" onClick={handleToggleMenu}>
      User Management
     <ul className={`${toggleMenu ? "transition-hide" : "transition-show"}`}>
        { stateUser?.auth === "ROLE_SUPER_ADMIN" ? (
     <li className="text-black hover:underline" onClick={handleMobileNav}>
      <Link to={"/dashboard/user-management/admin"}>Admin</Link>
     </li>
        )  : (
            <></>
        )}
     <li className="text-black hover:underline" onClick={handleMobileNav}>
      <Link to={"/dashboard/user-management/member"}>Member</Link>
     </li>
      </ul>    
  </li>
  <li className="text-black hover:underline" onClick={handleMobileNav}><Link to={"/dashboard/price-management"}>
   Price Management
  </Link></li>
  <li className="text-black hover:underline" onClick={handleMobileNav}><Link to={"/dashboard/stock-management"}>
   Stock Management
  </Link></li>
  <li className="text-black hover:underline" onClick={handleMobileNav}><Link to={"/dashboard/help-center"}>
   Help Center
  </Link></li>
  <li className="text-black hover:underline" onClick={handleMobileNav}><Link to={"/dashboard/setting"}>
    Settings
  </Link></li>
 
</ul>
</div>
    </div>
   
  );
};

export default MobileNav;
